<script setup lang="ts">
import type { PersonData } from '~/utils/crystallize/pieces'
import { NuxtLink } from '#components'
import { SolrParamsKey } from '#shared/solr'

const { person } = defineProps<{
  person: PersonData | null | undefined
}>()

const calculatedSlug = computed(
  () => person?.name?.replaceAll(/\s+/g, '-').replaceAll(/[^A-Zæøå-]/gi, '').toLowerCase(),
)

const { data: author } = useAuthorQuery(
  computed(() => ({
    [SolrParamsKey.Author]: calculatedSlug.value,
  })),
)

const slug = computed(() => author.value?.response.docs[0]?.slug)
</script>

<template>
  <component :is="$attrs.is || 'li'" v-if="person">
    <component
      :is="slug ? NuxtLink : 'div'"
      class="flex flex-col md:flex-row gap-s md:gap-5 items-center no-underline group p-5 bg-white text-primary rounded-4xl"
      :class="{
        'transition-all hover:contrast-75': !!slug,
      }"
      :to="slug ? {
        name: 'author',
        params: {
          slug,
        },
      } : undefined"
    >
      <CrystallizeImage
        v-if="person.image?.firstImage"
        :image="person.image.firstImage"
        class="min-w-56 size-56"
        :class="{
          'transition-transform group-hover:scale-110': !!slug,
        }"
      />

      <div class="flex flex-col">
        <h3 v-if="person.name" class="title-m mb-s md:mb-7" v-text="person.name" />
        <p v-if="person.title" class="mb-3 text-caption" v-text="person.title" />
        <CrystallizeRichText v-for="(block, i) in person.description" :key="i" class="text-sm" :block="block" />
      </div>
    </component>
  </component>
</template>
